export default __webpack_public_path__ + "static/media/1dc8c419c70e3e4b2141e83ad87066e81576090421890.8ec31183.webp";